<!-- IconDesignOnline.vue - "Design Online" icon (brush/design) -->
<template>
  <svg 
    width="35" 
    height="35" 
    viewBox="0 0 30 29" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="icon-design-online"
  >
    <path 
      d="M7.89372 17.37C5.27301 17.37 3.15749 19.4856 3.15749 22.1063C3.15749 24.1744 1.32615 25.2638 0 25.2638C1.45244 27.1898 3.93107 28.4213 6.31498 28.4213C9.804 28.4213 12.63 25.5953 12.63 22.1063C12.63 19.4856 10.5144 17.37 7.89372 17.37ZM29.5383 2.57721L27.4228 0.461694C27.2767 0.315339 27.1032 0.199226 26.9123 0.120003C26.7213 0.0407789 26.5165 0 26.3098 0C26.103 0 25.8983 0.0407789 25.7073 0.120003C25.5163 0.199226 25.3428 0.315339 25.1968 0.461694L11.0512 14.6072L15.3928 18.9488L29.5383 4.80324C29.6847 4.65719 29.8008 4.4837 29.88 4.29271C29.9592 4.10173 30 3.89699 30 3.69023C30 3.48346 29.9592 3.27873 29.88 3.08774C29.8008 2.89675 29.6847 2.72327 29.5383 2.57721Z" 
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconDesignOnline'
};
</script>

<style scoped>
.icon-design-online {
  display: block;
}
</style>
